module.exports = __webpack_public_path__ + "static/banner-mobile-0b12fdb225ced0f4fb8e5bcf6b94f27d.jpg";